import { Userauthcontext } from "../Context/Userauthcontext";
import { useContext } from "react";



export const Userauthcontexthooks = () => {

    const context = useContext(Userauthcontext)


    if (!context) {

        throw Error('userAuthContext must be used inside an AuthcontextProvider')
    }

    return context
}